// extracted by mini-css-extract-plugin
export default {"claim-buttons":"claimForm_claim-buttons__ZPu09","claim-submit":"claimForm_claim-submit__0UL-+"};